import {Box, Typography} from "@mui/material";
import {Button, Field, FieldsContainer, Form, Spacer, TextField, Toolbar} from "../../../../common";
import useManagePaymentsForm from "./useManagePaymentsForm";
import React from "react";
import I18n from "i18n-js";
import {ChangePasswordForm} from "../../my-profile/profileAPI";

export default function ManagePayments() {
  const {
    item,
    loading,
    preLoading,
    process,
    errors,
    onChange,
  } = useManagePaymentsForm();

  return (
    <Box maxWidth={"sm"}>
      <Typography variant="h1">
        {I18n.t("MyAccount.pages.billingAndPlans.billingDetails.managePayments")}
      </Typography>
      <Spacer h={2} />
      <Form
        item={item}
        errors={errors}
        onChange={onChange}
        translationCategory="ManagePaymentsForm.attributes"
      >
        <FieldsContainer>
          <Field xs={12} md={12}>
            <TextField id="billing_first_name"/>
          </Field>
          <Field xs={12} md={12}>
            <TextField id="billing_last_name"/>
          </Field>
          <Field xs={12} md={12}>
            <TextField id="billing_street"/>
          </Field>
          <Field xs={12} md={12}>
            <TextField id="billing_city"/>
          </Field>
          <Field xs={12} md={12}>
            <TextField id="billing_country"/>
          </Field>
          <Field xs={12} md={12}>
            <TextField id="billing_state"/>
          </Field>
          <Field xs={12} md={12}>
            <TextField id="billing_zip"/>
          </Field>
          <Field xs={12} md={12}>
            <TextField id="billing_phone"/>
          </Field>
        </FieldsContainer>
      </Form>
      <Spacer h={2} />
      <Toolbar>
        <Spacer right/>
        <Button
          loading={loading}
          onClick={() => {
            process();
          }}
        >
          {I18n.t("App.save")}
        </Button>

      </Toolbar>
    </Box>
  );
}